export const API_PATH_apiUsersInvitationsSendPost = '/services/users-invitations/send';
